import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { ListItem, Priority } from '@travel-planner/shared';
import { ItemCard } from './ItemCard';
import { AddItemForm } from './AddItemForm';

const TITLES: Record<Priority, string> = {
  must: 'Must',
  should: 'Should',
  could: 'Could',
};

const DOT: Record<Priority, string> = {
  must: 'var(--danger)',
  should: 'var(--warn)',
  could: 'var(--text-dim)',
};

export function Column({
  priority,
  items,
  tripId,
  countryId,
  dragDisabled,
}: {
  priority: Priority;
  items: ListItem[];
  tripId: string;
  countryId: string;
  dragDisabled: boolean;
}) {
  // Column itself is droppable so items can be dropped into an empty column.
  const { setNodeRef } = useDroppable({ id: `col:${priority}` });

  return (
    <div
      className="board-column d-flex flex-column p-3"
      style={{ background: 'var(--surface-2)', borderRadius: 'var(--radius)' }}
    >
      <h3 className="m-0 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.95rem' }}>
        <span
          aria-hidden
          style={{ width: 8, height: 8, borderRadius: '50%', background: DOT[priority], display: 'inline-block' }}
        />
        {TITLES[priority]} <span className="text-body-tertiary fw-normal">({items.length})</span>
      </h3>
      <div ref={setNodeRef} style={{ flex: 1, minHeight: 24 }}>
        <SortableContext items={items.map((i) => i.id)} strategy={verticalListSortingStrategy}>
          {items.map((item) => (
            <ItemCard
              key={item.id}
              item={item}
              tripId={tripId}
              countryId={countryId}
              dragDisabled={dragDisabled}
            />
          ))}
        </SortableContext>
      </div>
      <AddItemForm tripId={tripId} countryId={countryId} priority={priority} />
    </div>
  );
}
